import React from 'react';
import { AlertCircle, CheckCircle2, AlertTriangle, Info } from 'lucide-react';

export interface AlertProps {
  type?: 'error' | 'success' | 'warning' | 'info';
  title?: string;
  message: string;
  className?: string;
}

export const Alert: React.FC<AlertProps> = ({ type = 'error', title, message, className = '' }) => {
  if (!message) return null;

  const config = {
    error: {
      container: 'bg-rose-50/80 dark:bg-rose-950/20 text-rose-900 dark:text-rose-200 border-rose-200 dark:border-rose-900/40',
      icon: <AlertCircle className="w-4 h-4 text-rose-600 dark:text-rose-400 flex-shrink-0 mt-0.5" />,
    },
    success: {
      container: 'bg-emerald-50/80 dark:bg-emerald-950/20 text-emerald-900 dark:text-emerald-200 border-emerald-200 dark:border-emerald-900/40',
      icon: <CheckCircle2 className="w-4 h-4 text-emerald-600 dark:text-emerald-400 flex-shrink-0 mt-0.5" />,
    },
    warning: {
      container: 'bg-amber-50/80 dark:bg-amber-950/20 text-amber-900 dark:text-amber-200 border-amber-200 dark:border-amber-900/40',
      icon: <AlertTriangle className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />,
    },
    info: {
      container: 'bg-sky-50/80 dark:bg-sky-950/20 text-sky-900 dark:text-sky-200 border-sky-200 dark:border-sky-900/40',
      icon: <Info className="w-4 h-4 text-sky-600 dark:text-sky-400 flex-shrink-0 mt-0.5" />,
    },
  };

  const current = config[type];

  return (
    <div className={`flex items-start gap-3 p-3.5 rounded-lg border text-sm ${current.container} ${className}`}>
      {current.icon}
      <div className="flex-1">
        {title && <h5 className="font-semibold text-sm mb-0.5">{title}</h5>}
        <p className="leading-relaxed text-xs sm:text-sm">{message}</p>
      </div>
    </div>
  );
};
